module.exports = __webpack_public_path__ + "img/txt.2c8fd1d0.jpg";